module.exports = __webpack_public_path__ + "assets/img/tips.6e165cd1.png";